<template>
  <v-snackbar
    :timeout="-1"
    :value="notification.title"
    absolute
    top
    right
    color="primary"
    text
    style="z-index: 1000"
    @click.native="hideNotification()"
  >
    <div class="text-subtitle-2">
      {{ notification.title }}
    </div>
    <div
      class="text-body-2"
      v-if="notification.text"
      v-text="notification.text"
    ></div>
    <!-- eslint-disable-next-line vue/no-unused-vars -->
    <template v-slot:action="{ attrs }">
      <v-btn icon @click="hideNotification()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'NotificationView',
  computed: {
    ...mapState(['notification'])
  },
  methods: {
    ...mapMutations(['hideNotification'])
  }
}
</script>
